import React from 'react'

const MoreDetail = () => {
  return (
    <div>
      <h3>For children route</h3>
      <h1>About fish</h1>
    </div>
  )
}

export default MoreDetail;